import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import Cookies from "js-cookie";
import router from "./router";
Vue.use(router);
import store from "./store";
import plugins from "./plugins"; // plugins
Vue.use(plugins);
// 分页组件
import Pagination from "@/components/Pagination";
import "element-ui/lib/theme-chalk/display.css";
Vue.config.productionTip = false;
Vue.use(ElementUI);
//瀑布流
import { VueMasonryPlugin } from "vue-masonry";
Vue.use(VueMasonryPlugin);
// 组件拖动
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
Vue.component("vue-draggable-resizable", VueDraggableResizable);
// vant
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
// 校内
Vue.prototype.$version = 0;
// 校外
// Vue.prototype.$version = 1;
// 34路径
Vue.prototype.$uploadUrl = "/api";
// 校内路径
// Vue.prototype.$uploadUrl = "https://hncbxx.laohui.net/api";
// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
Vue.component("ImageUpload", ImageUpload);
// Header组件
// import Header from "./components/Header";
// Vue.component("Header", Header);
// 全局挂载
Vue.component("Pagination", Pagination);
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
